/**
 * Created by Alex Aguilar on 7/26/2016.
 */
(function () {
    'use strict';

    var checkBox = {
        templateUrl: 'app/components/checkBox/check-box.html',
        controller: checkBoxController,
        controllerAs: 'vm',
        bindings: {
            inline: '@',
            target: '@',
            label: '@',
            ngModel: '=',
            selectCheckbox: '=',
            checkRequire: '=',
            onChangeEvent: '&'
        }
    };

    angular
        .module('completeAir')
        .component('checkBox', checkBox);

    checkBoxController.$inject = ['$timeout'];

    function checkBoxController($timeout) {
        var vm = this;

        vm.$onInit = function(){
            vm.type = (vm.inline == undefined) ? "block" : "inline";
        }

        vm.someSelected = function (object) {
            return Object.keys(object).some(function (key) {
                return object[key];
            });
        }

        vm.handleChangeEvent = function(){
            $timeout(function () {
                vm.onChangeEvent();
            }, 50);
        }
    }
})();

